import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import { State } from '@app/core/store';
import { environment } from '@env/environment';
import { JwtHelperService, JWT_OPTIONS } from '@palmyra/angular-jwt-security';
const BASE_PATH = environment.basePathExternal;
const PREFIX = environment.prefix;

const ACCESS_TOKEN = `${PREFIX}_access_token`;

@Injectable({
  providedIn: 'root'
})
export class AdminAuthService {
  /***
     * Default constructor
     */
  constructor(
    private http: HttpClient,
    private jwtHelper: JwtHelperService,
    @Inject(JWT_OPTIONS) private accessTokenOpt: any,
    private store: Store<State>,
  ) { }

  /**
  
   * @param credential user to authenticate
   * @returns {Observable<any>} user token
   */
  authenticateUser(credential): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const body = new HttpParams({
      fromObject: {
        username: credential.username,
        password: credential.password,
      },
    }).toString();

    return this.http.post(`${BASE_PATH}/security/authenticate`, body, {
      headers,
    });
  }
  /**
   * Post the logout request using access token
   * @returns {Observable<any>}
   */
  logout(): void {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const body = new HttpParams({
      fromObject: {
        accessToken: this.accessTokenOpt.tokenGetter(),
      },
    }).toString();

    this.http
      .post(`${BASE_PATH}/security/logout`, body, {
        headers,
      })
      .subscribe(
        value => this.doLogout(),
        error => this.doLogout(),
      );
  }
  /**
   * Clear the localStorage and forward to login page
   */
  private doLogout() {
    //this.logout();
  }

  /**
   * Test if the current user is logged by checking if there is
   * an access token stored in the local storage or not
   * @return {boolean}
   */
  isLogged(): boolean {
    const token = this.accessTokenOpt.tokenGetter();
    if (token) {
      return this.jwtHelper.decodeToken(token) ? true : false;
    }
    return false;
  }
  
  isChangePasswordRequired(): boolean {
    const token = this.accessTokenOpt.tokenGetter();
    if (token) {
      const decodedToken = this.jwtHelper.decodeToken(token);
      return decodedToken !== undefined ? decodedToken.resetPwd : false;
    }
    return false;
  }
}